// pack-tracker-v2.js — isolated tier-selector tracker. Listens ONLY for [data-pack-v2-*].
// Pricing baked into messaging: 549 / 799 / 999 / 1799 (single / 2 / 3 / 6).
// Keep state() in sync with snippets/pack-selector.liquid initial-state block.
(function () {
  'use strict';
  var lastCount = -1, refreshTimer = null;

  function fetchCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }

  function modelProps() {
    if (window.PhoneModelSelector && typeof window.PhoneModelSelector.getProperties === 'function')
      return window.PhoneModelSelector.getProperties() || {};
    return {};
  }
  function hasModel() {
    if (!(window.PhoneModelSelector && window.PhoneModelSelector.getProperties)) return true;
    return Object.keys(modelProps()).length > 0;
  }
  function drawerSectionId() {
    var d = document.querySelector('cart-drawer');
    return d ? d.getAttribute('data-section-id') : null;
  }
  function addToCart(variantId) {
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    var props = modelProps();
    if (Object.keys(props).length) item.properties = props;
    var body = { items: [item] }, sid = drawerSectionId();
    if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (res) { return res.ok ? res.json() : null; });
  }

  function isCase(item) {
    if (item.properties && (item.properties._is_addon || item.properties._linked_to_product_id || item.properties['Add-on for'])) return false;
    var t = (item.product_title || item.title || '').toLowerCase();
    var ty = (item.product_type || '').toLowerCase();
    return t.indexOf('case') !== -1 || t.indexOf('cover') !== -1 || ty.indexOf('case') !== -1 || ty.indexOf('cover') !== -1;
  }
  function countCases(cart) {
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (isCase(cart.items[i])) n += cart.items[i].quantity;
    return n;
  }

  function state(count) {
    if (count <= 0) return { show: false };
    var status, msg, fill;
    if (count === 1)      { status = '1 / 3 added';          msg = 'Add 2 more for ₹999 (₹333/case)';                       fill = 33;  }
    else if (count === 2) { status = '2 / 3 added';          msg = '₹799 unlocked — 3rd case is just ₹200 more';            fill = 66;  }
    else if (count === 3) { status = '₹999 pack unlocked ✓'; msg = 'Add 3 more for the 6-pack at ₹1,799 (₹300/case)';       fill = 100; }
    else if (count === 4) { status = '4 cases added';        msg = 'Add 2 more for the 6-pack — just ₹125 each';            fill = 33;  }
    else if (count === 5) { status = '5 cases added';        msg = '⚡ Add 1 more — your total DROPS by ₹298 (6-pack: ₹1,799)'; fill = 66; }
    else if (count === 6) { status = '6-pack unlocked ✓';    msg = '₹300/case — best deal locked';                          fill = 100; }
    else                  { status = count + ' cases in cart'; msg = 'Best deal applied';                                   fill = 100; }
    return { show: true, fill: fill, status: status, msg: msg };
  }

  function updateUI(count) {
    if (count === lastCount) return;
    lastCount = count;
    var s = state(count);
    document.querySelectorAll('[data-pack-v2-tray]').forEach(function (el) { el.hidden = !s.show; });
    if (!s.show) return;
    document.querySelectorAll('[data-pack-v2-status]').forEach(function (el) { el.textContent = s.status; });
    document.querySelectorAll('[data-pack-v2-message]').forEach(function (el) { el.textContent = s.msg; });
    document.querySelectorAll('[data-pack-v2-fill]').forEach(function (el) { el.style.width = s.fill + '%'; });
  }

  function refresh() { return fetchCart().then(function (c) { updateUI(countCases(c)); }).catch(function () {}); }
  function debounced(d) { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, d || 200); }

  function notifyDrawer(res) {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.onPrepareBundledSections === 'function' && res && res.sections) {
      try { d.onPrepareBundledSections(res.sections); } catch (e) {}
    }
  }
  function openDrawer() { var d = document.querySelector('cart-drawer'); if (d && d.show) d.show(); }

  function ctaLabelForTier(tierEl, tier) {
    if (tier === '1') {
      var p = tierEl.querySelector('.ps-tier__price');
      return 'Add to cart' + (p ? ' · ' + p.textContent : '');
    }
    if (tier === '2') return 'Build your 2-pack →';
    return 'Build your 3-pack →';
  }

  function bindTiers() {
    var tiers = document.querySelectorAll('[data-pack-v2-tier]');
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('is-selected'); });
        t.classList.add('is-selected');
        var cta = document.querySelector('[data-pack-v2-add]');
        if (cta) cta.textContent = ctaLabelForTier(t, t.getAttribute('data-tier'));
      });
    });
  }

  function nudgeModelSelector() {
    var sel = document.querySelector('.phone-selector');
    if (!sel) {
      var err = document.querySelector('[data-pack-v2-error]');
      if (err) err.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
    sel.classList.remove('is-attention');
    void sel.offsetWidth;
    sel.classList.add('is-attention');
    setTimeout(function () { sel.classList.remove('is-attention'); }, 2400);
  }

  function onAdd(e) {
    var btn = e.target.closest('[data-pack-v2-add]');
    if (!btn) return;
    e.preventDefault();
    if (!hasModel()) {
      document.querySelectorAll('[data-pack-v2-error]').forEach(function (el) { el.hidden = false; });
      nudgeModelSelector();
      return;
    }
    document.querySelectorAll('[data-pack-v2-error]').forEach(function (el) { el.hidden = true; });
    var vid = btn.getAttribute('data-variant-id'); if (!vid) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    addToCart(vid).then(function (res) {
      btn.disabled = false; btn.textContent = orig;
      if (res) {
        notifyDrawer(res); openDrawer(); refresh();
        ['cart:updated', 'cart:refresh', 'cart:item-added'].forEach(function (n) {
          document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: res }));
        });
      }
    });
  }

  function onSelectorChange(e) {
    if (e.target && e.target.closest && e.target.closest('.phone-selector')) {
      document.querySelectorAll('[data-pack-v2-error]').forEach(function (el) { el.hidden = true; });
    }
  }

  function init() {
    bindTiers();
    document.addEventListener('click', onAdd);
    document.addEventListener('change', onSelectorChange);
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:item-removed', 'cart:item-quantity-updated']
      .forEach(function (n) { document.addEventListener(n, function () { debounced(200); }); });
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(function () { debounced(300); }).observe(d, { childList: true, subtree: true });
    refresh();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();